/**
 * Reusable "nothing here yet" placeholder.
 */

import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { OcppTheme } from './OcppTheme';

export interface OcppEmptyStateProps {
  /** MaterialIcons name. Defaults to `inbox`. */
  icon?: keyof typeof MaterialIcons.glyphMap;
  title: string;
  description?: string;
}

const OcppEmptyState: React.FC<OcppEmptyStateProps> = ({
  icon = 'inbox',
  title,
  description,
}) => {
  return (
    <View style={styles.empty}>
      <MaterialIcons name={icon} size={36} color={OcppTheme.textDim} />
      <Text style={styles.title}>{title}</Text>
      {description ? <Text style={styles.description}>{description}</Text> : null}
    </View>
  );
};

export default OcppEmptyState;

const styles = StyleSheet.create({
  empty: {
    paddingVertical: 32,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  title: {
    marginTop: 8,
    color: OcppTheme.textSecondary,
    fontSize: 15,
    fontWeight: '600',
    textAlign: 'center',
  },
  description: {
    marginTop: 6,
    color: OcppTheme.textMuted,
    fontSize: 13,
    lineHeight: 18,
    textAlign: 'center',
  },
});
